export default "__VITE_ASSET__DoNLzHH6__"